export function locationsMapActions() {
    const $window = $(window);
    const parent = $(".our-locations-holder");
    const locationsPinsListButton = parent.find(".pins-list .item button");
    const $slider = parent.find(".locations-map-slider");
    let sliderNav = "";
    let $current = "";
    let $total = "";

    function mobileSlider() {
        $slider.each(function () {
            let $this = $(this);
            sliderNav = $this.next(".locations-map-slider-nav");
            $current = sliderNav.find('.current');
            $total = sliderNav.find('.total');
            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        dots: false,
                        arrows: true,
                        appendArrows: sliderNav,
                        infinite: false,
                        fade: true,
                        speed: 300,
                        cssEase: 'ease',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                    }).on('init reInit afterChange', function (event, slick, currentSlide) {
                        let i = (currentSlide ? currentSlide : 0) + 1;
                        $current.text(i);
                        $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
                        $this.find(".item").removeClass("active");
                        $this.find(".slick-current .item").addClass("active");
                        $this.parents(".our-locations-holder").find(".locations-info-list .location-info-item").removeClass("active");
                        $this.parents(".our-locations-holder").find(".locations-info-list .location-info-item").eq(currentSlide).addClass("active");

                        $this.parents(".our-locations-holder").find(".pins-list .item").removeClass("active");
                        $this.parents(".our-locations-holder").find(".pins-list .item").eq(currentSlide).addClass("active");
                    });
                    $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
                    $current.text("1");
                    $this.parents(".our-locations-holder").find(".locations-info-list .location-info-item").eq(0).addClass("active");
                    $this.parents(".our-locations-holder").find(".pins-list .item").eq(0).addClass("active");
                }
            }
        });
    }

    $window.on("load resize", function () {
        mobileSlider();
    });
    locationsPinsListButton.on("click", function () {
        let $this = $(this);
        let thisParent = $this.parent();
        let index = $this.parent().index();
        thisParent.addClass("active").siblings().removeClass("active");
        $this.parents(".our-locations-holder").find(".locations-info-list .location-info-item").removeClass("active");
        $this.parents(".our-locations-holder").find(".locations-info-list .location-info-item").eq(index).addClass("active");
        $this.parents(".our-locations-holder").find(".locations-map-slider .item").removeClass("active");
        $this.parents(".our-locations-holder").find(".locations-map-slider .item").eq(index).addClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/locationsMapActions.js